const characters = {
  a: ['á', 'â', 'à', 'å', 'ã', 'ä'],
  e: ['è', 'ë', 'é', 'ê', 'ê'],
  o: ['ó', 'ô', 'ò', 'õ', 'ö'],
  i: ['í', 'î', 'ì', 'ï'],
  u: ['ú', 'û', 'ù', 'ü'],
  y: ['ý'],
  c: ['ç'],
  n: ['ñ'],
};

function convertCharacters(str: string): string {
  let convertedStr = str.toLowerCase();
  Object.keys(characters).map((character) => {
    const toConvertCharacters = characters[character];
    convertedStr = toConvertCharacters.reduce((acc, item) => {
      return acc.replace(item, character);
    }, convertedStr);
  });

  return convertedStr;
}

export { convertCharacters };
